import React from 'react';
import AppEntryItemHeader from '~/components/page/Apps/components/AppEntryItemHeader';
import { Body } from '~/components/atom/Typography';
import ToggleCheckbox from '~/components/molecule/ToggleCheckbox';
import TEST_ID from './index.testid';
import Icon from '~/components/atom/Icon';
import useTooltipLayer from '~/hooks/useTooltipLayer';
import JustificationContainer from '~/components/atom/JustificationContainer';

const text = {
  title: 'Toestemmingscheckbox',
  label: 'Toestemmingscheckbox tonen',
  description:
    'Toon een checkbox bij de disclaimer tekst, dit maakt het verplicht om de disclaimer te accepteren voordat het contactformulier kan worden verzonden.',
  tooltipMessage: `Volgens de ACM (Autoriteit Consument & Markt) gelden vanaf 1 juli 2026 strengere regels voor telemarketing op basis van de Telecommunicatiewet. 
\nConsumenten en kleine ondernemers mogen alleen nog telefonisch worden benaderd met een commercieel aanbod als zij vooraf expliciet toestemming hebben gegeven. Met een toestemmingscheckbox leg je die toestemming vast via het contactformulier, op een manier die voldoet aan de wettelijke eisen.
\nZorg dat je disclaimer tekst duidelijk beschrijft waarvoor bezoekers toestemming geven.`,
};

export type Props = {
  value: boolean;
  onChange: (value: boolean) => void;
  dataTestId?: string;
};

const ConsentCheckboxField: React.FCC<Props> = ({
  value,
  onChange,
  dataTestId = TEST_ID.TOGGLE,
}) => {
  const tooltipLayerProps = useTooltipLayer({
    tooltipMessage: (
      <Body color={{ group: 'white' }} whiteSpace="break-spaces">
        {text.tooltipMessage}
      </Body>
    ),
  });
  return (
    <JustificationContainer direction="column" width="100%">
      <AppEntryItemHeader>
        {text.title} <Icon name="question-mark" {...tooltipLayerProps} />
      </AppEntryItemHeader>

      <Body>{text.description}</Body>

      <ToggleCheckbox
        value={value}
        onChange={() => onChange(!value)}
        label={text.label}
        dataTestId={dataTestId}
      />
    </JustificationContainer>
  );
};

export default ConsentCheckboxField;
